import { EllipsisIcon } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@crossnokaye/ux-common/ckds';

import { Button } from '@/ux-common/components/button/button';

import { useJumpToEquipment } from './useJumpToEquipment';

export const JumpToEquipmentDropdown = () => {
  const { sections, getEquipmentBySection, handleEquipmentClick } = useJumpToEquipment();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="btn btn-tier3 btn-md btn-square" aria-label="Jump to equipment">
          <EllipsisIcon className="btn-icon" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-72" withPortal>
        <DropdownMenuLabel>Equipment Categories</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {sections?.map((section) => (
          <DropdownMenuSub key={section.id}>
            <DropdownMenuSubTrigger className="capitalize">{section.name}</DropdownMenuSubTrigger>
            <DropdownMenuSubContent className="max-h-[50vh] overflow-y-auto">
              <DropdownMenuLabel>Select Equipment</DropdownMenuLabel>
              {getEquipmentBySection(section)?.map((equipment) => (
                <DropdownMenuItem
                  key={`${section.name}-${equipment.referenceId}`}
                  onClick={() => handleEquipmentClick(equipment, section)}
                >
                  {equipment.title}
                </DropdownMenuItem>
              ))}
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
